// extracted by mini-css-extract-plugin
export default {"customNumberInput":"styles_customNumberInput__BPRIe"};